<template>
  <div class="page-iframe">
    <!-- Header -->
    <div
      class="header-box"
      :class="{ 'header-fixed': isHeaderFixed }"
      :style="{ backgroundColor: isHeaderFixed ? '#000' : 'transparent' }"
    >
      <!-- logo -->
      <!-- :style="active != 'home'?'':'visibility: hidden'" -->
      <img src="@/assets/home/logo.png" alt="" class="logo" />
      <!-- Nav -->
      <div class="href-box">
        <div
          @click="toHref(item)"
          class="header-item"
          v-for="(item, index) in routeList"
          :key="index"
          :class="{ 'header-active': item.name == active }"
        >
          {{ item.title }}
        </div>
      </div>
    </div>

    <!-- 路由视图 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCollapsed: false,
      menuData: [],
      breadCrumbList: [],
      title: "首页",
      btns: [],
      routeList: [
        { title: "Home 首页", name: "home" },
        { title: "Business 业务", name: "business" },
        { title: "Case 案例", name: "case" },
        { title: "About 关于", name: "about" },
        { title: "Team 团队", name: "team" },
        { title: "Contact 联系", name: "contact" },
      ],
      isHeaderFixed: false,
    };
  },
  computed: {
    active: {
      get() {
        return this.$store.state.route.activeRoute;
      },
      set(value) {
        this.$store.dispatch("updateActiveRoute", value);
      },
    },
  },
  created() {
    if (this.$route.name !== this.active) {
      this.active = this.$route.name;
    }
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    toHref(item) {
      this.$router.push({ name: item.name });
      this.active = item.name;
    },
    handleScroll() {
      // 判断滚动距离
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      this.isHeaderFixed = scrollTop > 100; // 100 是阈值，可根据需求调整
    },
  },
};
</script>

<style scoped lang="scss">
.page-iframe {
  background: #1e1e1e;
  width: 120rem;
}

.header-box {
  position: absolute;
  top: 0.6875rem;
  left: 18.06rem;
  width: calc(100% - 18.06rem * 2);
  background: none;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s ease; /* 添加过渡效果 */
  z-index: 1000; /* 确保 header 在最上层 */

  &.header-fixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0.6875rem 18.06rem; /* 保持原有 padding */
    background-color: #0d0d0d; /* 固定时的背景色 */
  }

  .logo {
    width: 4.5rem;
    height: 4.75rem;
    margin-right: 31.625rem;

    img {
      width: 100%;
    }
  }

  .href-box {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    width: 100%;

    .header-item {
      font-weight: 400;
      font-size: 1rem;
      color: #ffffff;
      cursor: pointer;

      &:hover {
        color: #e3b281;
      }
    }

    .header-active {
      color: #e3b281;
    }
  }
}
</style>
